import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  selectFilesInBasket,
  selectPackagesInBasket,
  selectPackagesInShop,
  selectPrintsInBasket,
} from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/selector';
import {
  FileInBasket,
  PrintInBasket,
  ShoppingCartState,
} from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';
import { first } from 'rxjs/operators';
import {
  addFileInBasketAction,
  addFileInPackageToBasketAction,
  deleteFileInBasketAction,
  deleteFileInPackageInBasketAction,
} from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/actions';
import { PrintInPackage } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/single-photo-product-options/single-photo-product-options.component';
import { AutoAddFileToBasketTogetherWithProductService } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/product-card/auto-add-file-to-basket-together-with-product.service';

@Injectable({
  providedIn: 'root',
})
export class AutoAddFileToBasketTogetherWithPrintInPackageServiceService {
  filesInBasket$ = this.store.pipe(select(selectFilesInBasket));
  printsInBasket$ = this.store.pipe(select(selectPrintsInBasket));
  packagesInBasket$ = this.store.pipe(select(selectPackagesInBasket));
  packagesInShop$ = this.store.pipe(select(selectPackagesInShop));

  constructor(
    private autoAddFileToBasketTogetherWithProductService: AutoAddFileToBasketTogetherWithProductService,
    private store: Store<{ shoppingCart: ShoppingCartState }>,
  ) {}

  autoAddFileToBasketTogetherWithPrint(
    selectPhotoId: string,
    print: PrintInPackage,
  ) {
    let announcement = false;
    let fileInBasket: FileInBasket = null;
    let printInBasket: PrintInBasket = null;
    let printsInThisPackageBasket = null;
    const printsInRemainingPackageBasket: Array<{
      packageInBasketId: string;
    }> = [];
    let fileInPackageInBasket: {
      isFull: boolean;
      printAndFileConfigId?: string;
      size: number;
      photoId: string;
      togetherWithPrint?: boolean;
      mode?: string;
    } = null;
    this.filesInBasket$.pipe(first()).subscribe((filesInBasket) => {
      fileInBasket = filesInBasket.find(
        ({ photoId }) => photoId === selectPhotoId,
      );
    });
    this.printsInBasket$.pipe(first()).subscribe((printsInBasket) => {
      printInBasket = printsInBasket.find(
        ({ photoId }) => photoId === selectPhotoId,
      );
    });
    this.packagesInBasket$.pipe(first()).subscribe((allPackagesInBasket) => {
      this.packagesInShop$.pipe(first()).subscribe((allPackagesInShop) => {
        const packageWithFile = allPackagesInBasket.find((p) =>
          p.file.find(({ photoId }) => photoId === selectPhotoId),
        );
        const file = packageWithFile?.file.find(
          ({ photoId }) => photoId === selectPhotoId,
        );
        if (!!file) {
          fileInPackageInBasket = {
            mode: allPackagesInShop.package
              .find(({ packageId }) => packageId === packageWithFile?.packageId)
              ?.printAndFileConfig.find(
                ({ printAndFileConfigId }) =>
                  printAndFileConfigId === file?.printAndFileConfigId,
              )?.mode,
            ...file,
          };
        }
        const thisPackage = allPackagesInBasket.find(
          ({ packageInBasketId }) =>
            packageInBasketId === print.packageInBasketId,
        );
        printsInThisPackageBasket = thisPackage.print.filter(
          ({ printAndFileConfigId, photoId }) =>
            photoId === selectPhotoId &&
            allPackagesInShop.package
              .find(({ packageId }) => packageId === thisPackage.packageId)
              .printAndFileConfig.find(
                (pAndF) => pAndF.printAndFileConfigId === printAndFileConfigId,
              ).mode === 'AnyImage',
        );
        allPackagesInBasket
          .filter(
            ({ packageInBasketId }) =>
              packageInBasketId !== print.packageInBasketId,
          )
          .forEach((p) => {
            if (
              !!p.print.filter(
                ({ photoId, printAndFileConfigId }) =>
                  photoId === selectPhotoId &&
                  allPackagesInShop.package
                    .find(({ packageId }) => packageId === p.packageId)
                    .printAndFileConfig.find(
                      (pAndF) =>
                        pAndF.printAndFileConfigId === printAndFileConfigId,
                    ),
              ).length
            ) {
              printsInRemainingPackageBasket.push({
                packageInBasketId: p.packageInBasketId,
              });
            }
          });
      });
    });
    if (fileInBasket) {
      this.store.dispatch(
        deleteFileInBasketAction({
          photoId: selectPhotoId,
        }),
      );
    }
    if (
      !fileInPackageInBasket?.togetherWithPrint ||
      !['OneImage', 'PickedImage'].includes(fileInPackageInBasket?.mode)
    ) {
      this.store.dispatch(
        deleteFileInBasketAction({
          photoId: selectPhotoId,
        }),
      );
    }
    if (
      !fileInPackageInBasket ||
      (!fileInPackageInBasket?.togetherWithPrint &&
        !!fileInPackageInBasket?.printAndFileConfigId &&
        !['OneImage', 'PickedImage'].includes(fileInPackageInBasket?.mode))
    ) {
      this.store.dispatch(
        addFileInPackageToBasketAction({
          file: {
            photoId: selectPhotoId,
            size: 0,
            isFull: true,
            togetherWithPrint: true,
          },
          packageInBasketId: print.packageInBasketId,
        }),
      );
      announcement = true;
    } else if (!printsInThisPackageBasket.length) {
      this.store.dispatch(
        deleteFileInPackageInBasketAction({
          photoId: selectPhotoId,
          packageInBasketId: print.packageInBasketId,
        }),
      );
      if (!!printsInRemainingPackageBasket.length) {
        this.store.dispatch(
          addFileInPackageToBasketAction({
            file: {
              photoId: selectPhotoId,
              size: 0,
              isFull: true,
              togetherWithPrint: true,
            },
            packageInBasketId:
              printsInRemainingPackageBasket[0].packageInBasketId,
          }),
        );
      }
      if (!!printsInRemainingPackageBasket.length) {
        this.store.dispatch(
          addFileInPackageToBasketAction({
            file: {
              photoId: selectPhotoId,
              size: 0,
              isFull: true,
              togetherWithPrint: true,
            },
            packageInBasketId:
              printsInRemainingPackageBasket[0].packageInBasketId,
          }),
        );
      } else if (!!printInBasket) {
        this.store.dispatch(
          addFileInBasketAction({
            file: {
              photoId: selectPhotoId,
              size: 0,
              isFull: true,
              togetherWithPrint: true,
              togetherWithProduct: false,
              filePricingId: 'togetherWithPrint',
              retouchLevelId: 'standard',
            },
          }),
        );
      } else {
        this.autoAddFileToBasketTogetherWithProductService.autoAddFileToBasketTogetherWithProduct();
      }
    }
    return announcement;
  }
}
